import { useState } from 'react';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'ホーム', href: '#home' },
    { label: 'サービス概要', href: '#services' },
    { label: 'ソリューション', href: '#solutions' },
    { label: '導入事例', href: '#case-studies' },
    { label: '会社情報', href: '#company' },
    { label: 'お問い合わせ', href: '#contact' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const navHeight = 144; // h-36 = 9rem = 144px
      const elementTop = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementTop - navHeight, behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 lg:px-12">
          <div className="flex items-center justify-between h-36">
            <div className="flex items-center">
              <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="flex items-center gap-4">
                {scrolled && (
                  <img
                    src="https://static.readdy.ai/image/92ade1316d46486de905be456a9abf47/f2440a7f620b803de433f68c936617de.png"
                    alt="株式会社プラスゼット"
                    className="h-20 w-auto object-contain bg-white p-1 rounded"
                  />
                )}
                <span
                  className="text-5xl font-bold whitespace-nowrap"
                  style={
                    scrolled
                      ? {
                          fontSize: '2.8rem',
                          color: '#111111',
                          WebkitTextStroke: '0px',
                          textShadow: 'none',
                        }
                      : {
                          fontSize: '2.8rem',
                          color: 'white',
                          WebkitTextStroke: '0px',
                          textShadow: 'none',
                        }
                  }
                >
                  株式会社プラスゼット
                </span>
              </a>
            </div>

            <nav className="hidden lg:flex items-center space-x-8">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    scrolled
                      ? 'text-gray-700 hover:text-teal-600'
                      : 'text-white hover:text-teal-300'
                  }`}
                >
                  {item.label}
                </a>
              ))}
            </nav>

            <button
              className="lg:hidden p-2 cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <div className="w-6 h-5 flex flex-col justify-between">
                <span
                  className={`block h-0.5 w-full transition-all ${
                    scrolled ? 'bg-gray-800' : 'bg-white'
                  }`}
                ></span>
                <span
                  className={`block h-0.5 w-full transition-all ${
                    scrolled ? 'bg-gray-800' : 'bg-white'
                  }`}
                ></span>
                <span
                  className={`block h-0.5 w-full transition-all ${
                    scrolled ? 'bg-gray-800' : 'bg-white'
                  }`}
                ></span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileMenuOpen(false)}
          ></div>
          <div className="absolute top-20 right-0 w-64 bg-white shadow-xl">
            <nav className="flex flex-col p-6">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="py-3 text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      )}
    </>
  );
}
